<ng-container
  *ngIf="(isReady$ | async) && !(isAppLoading$ | async); else loadingTmpl">
  <rd-core-main-container #container>
    <vma-core-header
      main-header
      role="header"
      aria-label="site header"
      tabindex="-1"
      [authRenderState]="container.authRenderState$ | async"
      [pointsSummary]="container.pointsSummary$ | async"
      [loyaltyCurrencySelected]="
        container.loyaltyCurrencySelected$ | async
      "></vma-core-header>
    <vma-footer main-footer></vma-footer>
  </rd-core-main-container>
</ng-container>

<ng-template #loadingTmpl>
  <div class="flex h-screen w-screen items-center justify-center">
    <rd-shared-spinner class="h-[140px] w-[140px]"></rd-shared-spinner>
  </div>
</ng-template>
